export default class BProfileArticleThumbnails
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `.profile-article-thumbnails`;

	setArticles(articles)
	{
		this.el.innerHTML = null;

		articles.forEach(article => {
			this.el.appendChild(article);
		});
	}
}
